import { Controller } from "@hotwired/stimulus"

// The mobile bottom nav is a native-style horizontal toolbar strip: items sit at
// their natural width and the row scrolls left/right when there are more items
// than fit. On connect this scrolls the ACTIVE item into view (centered) so the
// current tab is never stranded off-screen — CSP-safe (no inline JS).
export default class extends Controller {
  connect() {
    const active = this.element.querySelector("[aria-current='page']")
    if (!active) return
    // "auto" (not "smooth") so it lands instantly on load / Turbo navigation and
    // doesn't animate a jump the operator didn't ask for.
    active.scrollIntoView({ inline: "center", block: "nearest", behavior: "auto" })
  }
}
